import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import IconMenuButton from 'components/layout/IconMenuButton'
import MenuButton from 'components/layout/MenuButton'
import icons from 'settings/icons'

const DeleteIcon = icons.delete
const TaskIcon = icons.task
const FolderIcon = icons.folder
const MoreIcon = icons.more
const ExpandIcon = icons.expand
const ContractIcon = icons.contract
const PDFIcon = icons.pdf

const useStyles = makeStyles(theme => ({
  button: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
    color: theme.palette.grey[700],
  },
}))

const OptionsButton = ({
  item,
  topLevel,
  large,
  readOnly,
  sortMode,
  onAddItem,
  onOpenTaskWindow,
  onOpenDeleteWindow,
  onExpandChildren,
  onContractChildren,
  onExportPDF,
  showAll,
}) => {

  const classes = useStyles()


  const options = []

  if(!readOnly && showAll) {
    if(item.type == 'folder') {
      options.push({
        title: 'Add Task',
        icon: TaskIcon,
        handler: () => onOpenTaskWindow(item.id),
      })
      // options.push({
      //   title: 'Add Folder',
      //   icon: FolderIcon,
      //   handler: () => onAddItem({
      //     parent: item.id,
      //     type: 'folder',
      //     resource: {
      //       type: 'folder',
      //       name: 'New Folder',
      //     }
      //   }),
      // })
    }

    if(item.id != 'root') {
      options.push({
        title: 'Delete',
        icon: DeleteIcon,
        handler: () => onOpenDeleteWindow(item)
      })
    }
  }
  

  if(topLevel) {
    if(!sortMode) {
      options.push({
        title: 'Expand All',
        icon: ExpandIcon,
        handler: () => onExpandChildren(item.id)
      })
    }
    options.push({
      title: 'Expand Folders',
      icon: ExpandIcon,
      handler: () => onExpandChildren(item.id, 'rootfolders')
    })
    options.push({
      title: 'Contract All',
      icon: ContractIcon,
      handler: () => onContractChildren(item.id)
    })
  }

  if(topLevel && onExportPDF) {
    options.push({
      title: 'Export PDF',
      icon: PDFIcon,
      handler: () => onExportPDF(item.id)
    })
  }

  if(options.length <= 0) return null

  return large ? (
    <MenuButton 
      title="Options"
      icon={ MoreIcon }
      items={ options }
      buttonProps={{
        variant: 'outlined',
        className: classes.button,
        size: 'small',
      }}
    />
  ) : (
    <IconMenuButton
      buttonProps={{
        size: "small"
      }}
      items={ options }
    >
      <MoreIcon fontSize="small" />
    </IconMenuButton>
  )

}

export default OptionsButton